export const ENV = process.env.VUE_APP_ENV || process.env.NODE_ENV

/**
 * Get endpoint function.
 */

export function getBaseURL () {
  switch (ENV) {
    case 'development':
      return 'http://localhost:8000'
    case 'staging':
      return 'https://stg-twf.admanawards.com'
    case 'production':
      return 'https://admanawards.com'
    default:
      return ''
  }
}

export function getApiBaseURL () {
  if (ENV === 'staging' && process.env.NODE_ENV === 'development') {
    return '/stg-api'
  }

  return getBaseURL()
}

export const getBaseMetaTitle = 'Adman Awards & Symposium'
export const getBaseMetaCurrentYear = '2025'
export const getBaseCurrentYear = '2025'
